module.exports = __webpack_public_path__ + "static/img/iphone2.6c107fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/commonproblem/nobindmsg/iphone/iphone2.png
// module id = H33f
// module chunks = 0